export const EVENT_MEDIA_FOLDER = `
	query eventMediaFolder(
		$event_id: Uint
		$search_term: String
		$offset: Uint
		$items_per_page: Uint
	) {
		eventMediaFolder(
			event_id: $event_id
			search_term: $search_term
			offset: $offset
			items_per_page: $items_per_page
		) {
			libraries {
				id
				name
				description
				updated_at
			}
			media {
				nodes {
					id
					name
					src
					type
					hidden
					size
					updated_at
					mime_type
				}
				page_info {
					has_next_page
					total_count
				}
			}
		}
	}
`;

export const MEDIA = `
	query media($id: Uint) {
		media(id: $id) {
			id
			name
			src
			type
			mime_type
			hidden
			size
			should_cache
			updated_at
			library {
				id
			}
		}
	}
`;
